import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from "./components/dummy/users.component";
import { SearchComponent } from "./components/dummy/search.component";
import { CreateComponent } from "./components/dummy/create.component";
import { MainUsersComponent } from "./components/main-users.component";
import { MainUserComponent } from "./components/main-user.component";
import { RouterModule } from '@angular/router';
import { UsersRoutes, routableComponents } from './users.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UsersService } from "../../injections/users.service";
import { LoaderService } from "../../common/loadingBar/loader.service";
import { DataComponent } from "./components/dummy/data.component";
import { OfficesComponent } from "./components/dummy/offices.component";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { UserInfoComponent } from './components/dummy/user-services.component';
import { UserPaymentComponent } from './components/dummy/user-payment.component';
import { UserAddressComponent } from './components/dummy/user-address.component';
import { UserCleanersComponent } from './components/dummy/user-cleaners.component';
import { ModalContactComponent } from './components/dummy/modal-contact.component';
import {SharedModule} from "../../common/shared.module";
import { FilterByOffice } from '../../pipes/filter-byOffice.pipe';
import { ModalAddressComponent } from './components/dummy/modal-address.component';
import { ModalDisclaimerMailComponent } from './components/dummy/modal-disclaimer-mail.component';
import { ModalBillComponent } from './components/dummy/modal-bill.component';


@NgModule({
  declarations: [
    MainUsersComponent, MainUserComponent, UsersComponent, SearchComponent, CreateComponent, DataComponent, OfficesComponent, 
    UserInfoComponent, ModalContactComponent, FilterByOffice, UserPaymentComponent, UserAddressComponent,
    UserCleanersComponent, ModalAddressComponent, ModalDisclaimerMailComponent, ModalBillComponent
  ],
  imports: [
    CommonModule,
    UsersRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
  ],
  providers: [UsersService,LoaderService]
})

export class UsersModule{} 


// WEBPACK FOOTER //
// ./src/app/modules/users/users.module.ts